import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ButtonComponent } from 'sharedGuiSmall/components/button/button.component';

export interface Draggable {
    onMouseDown(ev: MouseEvent): void;
    onMouseMove(ev: MouseEvent): void;
    onMouseUp(ev: MouseEvent): void;
    onMouseLeave(ev: MouseEvent): void;
    getEl(): HTMLElement;
    isDragging(): boolean;
    getDragData(): any;
    getXStart(): number;
    getYStart(): number;
    getDeltaX(): number;
}

@Injectable({ providedIn: 'root' })
export class DragDropManagerService {


    private draggables: Map<Element, Draggable> = new Map<Element, Draggable>();
    private dropTargets: Map<Element, any> = new Map<Element, any>();
    private disableButtons: Array<ButtonComponent> = [];

    private activeDraggable: Draggable | undefined;

    private dragstart: Subject<any> = new Subject<any>();

    private dragend: Subject<any> = new Subject<any>();

    public addDraggable(draggable: Draggable): void {

        this.draggables.set(draggable.getEl(), draggable);

    }

    public removeDraggable(draggable: Draggable): void {

        this.draggables.delete(draggable.getEl());

    }

    public addDropTarget(dropTarget: any): void {

        this.dropTargets.set(dropTarget.getEl(), dropTarget);

    }

    public isDragActive(): boolean {

        return this.activeDraggable ? true : false;

    }

    public setActiveDraggable(dr?: Draggable): void {

        this.activeDraggable = dr;

        this.disableButtons.forEach((btn) => {
            if (this.activeDraggable) {
                btn.disableHover(true);
            }
            else {
                btn.disableHover(false);
            }
        });

        if (this.activeDraggable) this.dragstart.next(1);
        else this.dragend.next(1);


    }

    public getActiveDraggable(): Draggable | undefined {

        return this.activeDraggable;

    }

    public addDisableButton(btn: ButtonComponent) {
        this.disableButtons.push(btn);
    }

    public getDraggable(element: Element): Draggable | undefined {

        return this.draggables.get(element);

    }

    public getDragStart(): Subject<any> {

        return this.dragstart;

    }

    public getDragEnd(): Subject<any> {

        return this.dragend;

    }

    ngOnDestroy() {
        this.dragstart.complete();
        this.dragend.complete();
    }
}